<template>
    <div class="ah-page user-index-page">
        <div class="page-header bottom-margin" v-if="!isFirstTimeAndNoAccounts">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>帳號管理</h1>
                    </div>
                    <div class="actions" style="display: flex; justify-content: flex-end;">
                        <el-input placeholder="搜尋：姓名..." class="search" v-model="conditions.nam" @keyup.enter.native="handleSearchInputEnter" style="margin-right: 10px; max-width: 300px">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="updateData(true)"></i>
                        </el-input>
                        <el-button v-if="datas.length > 0 && !isQR()" @click="onUploadSheet" icon="el-icon-download">批次匯入</el-button>
                        <el-button v-if="datas.length > 0 && isEnableExportData" :loading="isExporting" @click="onExportSheet" icon="el-icon-upload2">匯出</el-button>
                        <el-button type="highlight" @click="handleAddBtnClick">新增帳號</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isFirstTimeAndNoAccounts" style="height: 120px;">
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body" style="border-bottom: 1px solid #eee">
                    <div class="account-amt">可用帳號 {{ accountMaxNum }} 個 / 已啟用帳號 {{ accountUsedNum }} 個</div>
                    <el-alert type="warning" style="margin-top: 5px" center v-if="status == 'success' && accountUsedNum >= accountMaxNum" :closable="false"
                        >員工人數已達您購買方案的上限。如需增加請聯絡客服人員。</el-alert
                    >
                </div>
                <div class="panel-header small">
                    <div class="panel-title">
                        <el-select v-model="conditions.TYP" @change="updateData(true)" size="small" style="margin-right: 10px">
                            <el-option label="Sokuji帳號" :value="1" />
                            <el-option label="員工收款帳號" :value="2" />
                        </el-select>
                        <el-select v-model="conditions.ONF" placeholder="所有狀態" @change="updateData(true)" size="small" style="margin-right: 10px">
                            <el-option v-for="item in userStatus" :key="item.key" :label="item.value" :value="item.key" />
                        </el-select>
                        <el-select v-model="conditions.DEP_SNO" filterable placeholder="所有部門" @change="updateData(true)" size="small" style="margin-right: 10px">
                            <el-option v-for="item in departmentList" :key="item.sno" :label="item.deP_NAM" :value="item.sno" />
                        </el-select>
                        <div style="display: inline-block; margin-left: 10px">
                            <el-button size="small" v-if="isSAAdmin" @click="resetAdminPassDialog.visible = true">重設帳號管理員密碼</el-button>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <div v-if="isFirstTimeAndNoAccounts">
                        <div class="first-instruction-card">
                            <div class="title">歡迎，讓我們開始吧！</div>
                            <div class="description">
                                <p style="margin-bottom: 30px;">請先建立第一組屬於您的帳號</p>
                                <el-button type="highlight" @click="handleAddBtnClick" :disabled="accountMaxNum == accountUsedNum">新增帳號</el-button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <el-table v-loading="status == 'loading'" :data="datas" style="width: 100%" class="ah-el-data-table" empty-text="沒有資料" ref="accountTable">
                            <el-table-column label="#" type="index" :index="getIndex"></el-table-column>
                            <el-table-column label="狀態" width="80">
                                <template slot-scope="scope">
                                    <span class="ah-status pending" v-if="scope.row.onf == 1">使用中</span>
                                    <span class="ah-status done" v-else>已停用</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nam" label="名稱">
                                <template slot-scope="scope">
                                    <div class="strong">{{ scope.row.nam }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nam" label="帳號" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div class="">{{ scope.row.eml }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="conditions.TYP === 1" prop="hasPassword" label="密碼" width="100">
                                <template slot-scope="scope">
                                    <div class="">
                                        <img v-if="scope.row.hasPassword" src="@/assets/img/green_check.svg" style="width: 18px" alt="已設定" />
                                        <div v-if="!scope.row.hasPassword" style="color: #888; font-size: 10pt">
                                            未設定
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column key="deP_NAM" prop="deP_NAM" label="部門"> </el-table-column>
                            <el-table-column v-if="conditions.TYP === 1 && isActivePage" prop="grP_NAM" key="grP_NAM" label="身份" />
                            <el-table-column v-if="conditions.TYP === 1 && isActivePage" prop="resetPawMailDate" key="resetPawMailDate" width="150">
                                <template slot="header">
                                    <el-button type="text" @click="switchDateCellType">
                                        <div v-if="dateCellType === 'passMail'">密碼信寄出時間</div>
                                        <div v-if="dateCellType === 'lastLogin'">最後登入時間</div>
                                    </el-button>
                                </template>
                                <template slot-scope="scope">
                                    <div>
                                        <span style="font-size: 10pt">
                                            <div v-if="dateCellType === 'passMail' && scope.row.resetPawMailDate">
                                                {{ formatDatetime(scope.row.resetPawMailDate) }}
                                            </div>
                                            <div v-if="dateCellType === 'lastLogin' && scope.row.logiN_TIME">
                                                {{ formatDatetime(scope.row.logiN_TIME) }}
                                            </div>
                                        </span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="!isActivePage" prop="downtime" key="downtime" label="停用日期">
                                <template slot-scope="scope">
                                    {{ scope.row.downtime | dateFormater("YYYY-MM-dd hh:mm") }}
                                </template>
                            </el-table-column>
                            <el-table-column v-if="!isActivePage" prop="mem" key="mem" show-overflow-tooltip label="備註"> </el-table-column>
                            <el-table-column prop="grP_NAM" label="操作" width="160">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="conditions.TYP === 1" class="item" effect="dark" :content="getSendEmailTooltipContent(scope.row)" placement="top">
                                        <span style="margin-right: 10px">
                                            <el-button
                                                size="small"
                                                @click="sendPasswordEmail(scope.row)"
                                                :loading="isSendingEmail"
                                                :disabled="!scope.row.onf"
                                                icon="el-icon-message"
                                            ></el-button>
                                        </span>
                                    </el-tooltip>
                                    <el-button size="small" type="primary" plain @click="handleDataRowClick(scope.row)" v-if="scope.row.sno != 1">編輯</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            layout="prev, pager, next"
                            :page-size.sync="conditions.PageSize"
                            :total.sync="totalDataCount"
                            :current-page.sync="conditions.PageNum"
                            :small="isMobile()"
                            @current-change="handlePageChange"
                            class="pagination"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <ResetAdminPassDialog :visible="resetAdminPassDialog.visible" @close="onClose" />
        <BatchImportDialog :visible="batchImportDialog.visible" @close="onBatchImportDialogClose" />
    </div>
</template>
<script>
import moment from 'moment';
import ExcelJS from 'exceljs';
import { userStatus } from '@/assets/commonData/options';
import ResetAdminPassDialog from './ResetAdminPassDialog.vue';
import BatchImportDialog from './BatchImportDialog.vue';

export default {
    name: 'staff-page',
    components: { ResetAdminPassDialog, BatchImportDialog },

    data() {
        return {
            userStatus,
            status: '',
            conditions: {
                ONF: '1',
                nam: '',
                DEP_SNO: '',
                TYP: 1,
                PageNum: 1,
                PageSize: 20,
            },
            datas: [],
            dateCellType: 'lastLogin', // passMail (密碼信寄出時間) | lastLogin (最後登入時間)
            departmentList: [],
            accountUsedNum: 0,
            accountMaxNum: 0,
            totalDataCount: 0,
            isSendingEmail: false,
            resetAdminPassDialog: {
                visible: false,
            },
            batchImportDialog: {
                visible: false,
            },
            isExporting: false,
        };
    },
    mounted() {
        // 分頁
        if (this.$route.query.page) {
            this.conditions.PageNum = parseInt(this.$route.query.page, 10);
        }

        if (this.$route.query.typ) {
            this.conditions.TYP = Number(this.$route.query.typ);
        }

        // 載入資料
        this.updateData();

        // 取得部門下拉選單
        this.$api({
            url: '/StaffManagementPage/GetDepartmentOptions',
            method: 'GET',
        }).then((resp) => {
            this.departmentList = resp.data.options;
            this.departmentList.splice(0, 0, { sno: '', deP_NAM: '所有部門' });
        });
    },
    computed: {
        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        iniT_FIN() {
            return this.$store.getters['menu/companyInfo'].iniT_FIN;
        },
        isEnableExportData() {
            return this.$store.getters['menu/companyInfo'].exP_FLG === 1;
        },
        isActivePage() {
            return this.conditions.ONF === '1';
        },
        isFirstTimeAndNoAccounts() {
            if (this.status !== 'loading') {
                if (this.conditions.ONF === '1' && this.accountUsedNum === 0) {
                    return true;
                }
            }
            return false;
        },
    },
    methods: {
        getIndex(index) {
            return (this.conditions.PageNum - 1) * this.conditions.PageSize + index + 1;
        },

        formatDatetime(timecode) {
            return moment(timecode).format('YYYY-MM-DD HH:mm');
        },
        switchDateCellType() {
            if (this.dateCellType === 'passMail') {
                this.dateCellType = 'lastLogin';
            } else {
                this.dateCellType = 'passMail';
            }
            this.$refs.accountTable.$children.forEach((child) => child.$forceUpdate());
        },
        handlePageChange() {
            this.$router.replace({
                name: 'staff',
                query: { page: this.conditions.PageNum },
            });
            this.updateData();
        },

        handleAddBtnClick() {
            this.$router.push({ name: 'staff-add' });
        },

        handleDataRowClick(data) {
            this.$router.push({
                name: 'staff-edit',
                params: { sno: data.sno },
            });
        },

        handleSearchInputEnter() {
            this.updateData(true);
        },

        sendPasswordEmail(staff) {
            this.$confirm(`確定要向${staff.nam}寄送密碼設定信？`, {
                title: '提示',
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.sendPasswordEmailAction(staff.sno);
            });
        },

        sendPasswordEmailAction(sno) {
            this.isSendingEmail = true;

            this.$api({
                url: '/StaffManagementPage/SendResetPasswordEmail',
                method: 'post',
                data: { sno },
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '認證信已寄出。',
                        type: 'success',
                    });
                })
                .finally(() => {
                    this.isSendingEmail = false;
                });
        },

        updateData(resetPageNum = false) {
            this.status = 'loading';
            this.errorMsg = '';

            if (resetPageNum) this.conditions.PageNum = 1;

            this.$api({
                method: 'GET',
                url: 'StaffManagementPage/GetStaffList',
                params: this.conditions,
            }).then((resp) => {
                this.status = 'success';
                this.datas = resp.data.staffs;
                this.accountMaxNum = resp.data.cnt;
                this.accountUsedNum = resp.data.rnt;
                this.totalDataCount = resp.data.totalNum;
            });
        },

        getSendEmailTooltipContent(row) {
            if (!row.onf) return '帳號已停用';
            return '發送密碼設定信';
        },

        onClose() {
            this.resetAdminPassDialog.visible = false;
        },

        onUploadSheet() {
            this.batchImportDialog.visible = true;
        },
        onBatchImportDialogClose(refresh) {
            this.batchImportDialog.visible = false;
            if (refresh) this.updateData();
        },
        async onExportSheet() {
            this.isExporting = true;
            try {
                // 取得所有部門選項，建立部門對照表 (sno -> deP_NAM)
                const depResp = await this.$api({
                    url: '/StaffManagementPage/GetDepartmentOptions',
                    method: 'GET',
                });
                const departments = depResp.data.options || [];
                const depMap = {};
                departments.forEach((d) => {
                    depMap[d.sno] = d.deP_NAM;
                });

                // 取得所有帳號列表，建立主管姓名對照表 (sno -> nam)
                const staffListResp = await this.$api({
                    url: '/StaffManagementPage/GetStaffList',
                    params: {
                        PageSize: 999,
                        PageNum: 1,
                        ONF: 1,
                    },
                    method: 'GET',
                });
                const staffs = (staffListResp.data.staffs || []).filter((x) => x.sno !== 1);
                const staffMap = {};
                staffs.forEach((s) => {
                    staffMap[s.sno] = s.nam;
                });

                // 批次取得每個帳號的詳細內容
                const detailedStaffs = await Promise.all(
                    staffs.map(async (s) => {
                        try {
                            const resp = await this.$api({
                                url: `/StaffManagementPage/GetStaff?sno=${s.sno}`,
                                method: 'GET',
                            });
                            return resp.data.staff;
                        } catch (err) {
                            console.error(`取得帳號編號 ${s.sno} 詳細資料失敗`, err);
                            return null;
                        }
                    }),
                );

                // 欄位定義，符合匯入範本的格式
                const columns = [
                    {
                        header: '帳號類型', key: 'typ', width: 15, required: true,
                    },
                    {
                        header: 'Sokuji 帳號身份', key: 'employee', width: 22, required: true, hint: '一般員工非必填',
                    },
                    {
                        header: '帳號(E-mail)', key: 'eml', width: 26, required: true, hint: '一般員工非必填',
                    },
                    {
                        header: '姓名', key: 'nam', width: 15, required: true,
                    },
                    {
                        header: '身分證號碼', key: 'idNumber', width: 18, required: true,
                    },
                    {
                        header: '專案代碼 (2碼，英文或數字)', key: 'pJ_NO', width: 28, required: true, hint: '一般員工、外部人員非必填',
                    },
                    {
                        header: '所屬部門', key: 'deP_SNO', width: 20, required: true, hint: '外部人員非必填',
                    },
                    {
                        header: '直屬主管', key: 'boS_SNO', width: 20, required: true, hint: '外部人員非必填',
                    },
                    { header: '備註', key: 'mem', width: 20 },
                    { header: '薪轉銀行', key: 'stafF_BNK_BOO', width: 15 },
                    { header: '薪轉分行', key: 'stafF_BNK_DOO', width: 15 },
                    { header: '薪轉帳號', key: 'stafF_BNK_ACC', width: 20 },
                    { header: '薪轉帳號戶名', key: 'stafF_BNK_TPC', width: 18 },
                    {
                        header: '身份功能', key: 'grP_NO', width: 26, required: true, hint: '外部人員、一般員工非必填',
                    },
                    { header: '身份預設權限功能', key: 'preset_auth', width: 26 },
                ];

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('匯入資料');
                worksheet.columns = columns.map((col) => ({ header: col.header, key: col.key, width: col.width }));

                const exportHeaderRow = worksheet.getRow(1);
                columns.forEach((col, idx) => {
                    const cell = exportHeaderRow.getCell(idx + 1);
                    let text = col.required ? `*${col.header}` : col.header;
                    if (col.hint) text += `\r\n(${col.hint})`;
                    cell.value = text;

                    cell.font = { bold: true, size: 10 };
                    cell.alignment = { wrapText: true, vertical: 'top', horizontal: 'center' };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } };
                });
                exportHeaderRow.height = 40;

                // 寫入每個帳號的內容
                detailedStaffs.forEach((item) => {
                    if (!item) return;

                    let sokujiIdentity = '';
                    if (item.typ === 1) {
                        sokujiIdentity = item.employee ? '員工' : '外部人員';
                    }

                    worksheet.addRow({
                        typ: item.typ === 1 ? 'sokuji帳號' : '員工收款帳號',
                        employee: sokujiIdentity,
                        eml: item.eml || '',
                        nam: item.nam || '',
                        idNumber: item.idNumber || '',
                        pJ_NO: item.pJ_NO || '',
                        deP_SNO: depMap[item.deP_SNO] || '',
                        boS_SNO: staffMap[item.boS_SNO] || '',
                        mem: item.mem || '',
                        stafF_BNK_BOO: item.stafF_BNK_BOO || '',
                        stafF_BNK_DOO: item.stafF_BNK_DOO || '',
                        stafF_BNK_ACC: item.stafF_BNK_ACC || '',
                        stafF_BNK_TPC: item.stafF_BNK_TPC || '',
                        grP_NO: '', // 依需求：角色權限留白
                        preset_auth: '',
                    });
                });

                // 設定文字格式 (避免電話或帳號數字被 Excel 自動轉為科學記號或去零)
                worksheet.eachRow((r, rowNum) => {
                    if (rowNum === 1) return;
                    const cell5 = r.getCell(5);
                    const cell10 = r.getCell(10);
                    const cell11 = r.getCell(11);
                    const cell12 = r.getCell(12);
                    cell5.numFmt = '@'; // 身分證字號
                    cell10.numFmt = '@'; // 薪轉銀行
                    cell11.numFmt = '@'; // 薪轉分行
                    cell12.numFmt = '@'; // 薪轉帳號
                });

                worksheet.views = [{ state: 'frozen', ySplit: 1 }];

                const today = new Date();
                const dateStr = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `帳號資料_${dateStr}.xlsx`;
                a.click();
                URL.revokeObjectURL(url);
            } catch (error) {
                console.error(error);
                this.$message({
                    showClose: true,
                    message: '匯出失敗，請重試',
                    type: 'error',
                });
            } finally {
                this.isExporting = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";

.user-index-page {
    .account-amt {
        // text-align: right;
        font-size: 10.5pt;
        color: #777;
        text-align: center;
    }

    .first-instruction-card {
        text-align: center;
        padding: 120px 20px;

        > .title {
            font-size: 18pt;
            font-weight: bold;
            margin-bottom: 15px;
        }
        > .description {
            font-size: 13pt;
            color: #666;
        }
    }
}
</style>
